import React from 'react';
import { Container } from 'react-bootstrap';
import Button from '../../../../components/Button/Button';
import RetireSummaryModal from './RetireSummaryModal';
import useModal from '../../../../hooks/useModal';

const RetireSummaryModalDemo = () => {
  const [showModal, handleShow, handleClose] = useModal();

  return (
    <Container>
      <Container className="mt-10">
        <h4>Retire Summary Modal Demo</h4>
        <Button onMouseDown={handleShow}>Open Modal</Button>
        <RetireSummaryModal
          showRetireSummaryModal={showModal}
          handleCloseRetireSummaryModal={handleClose}
        />
      </Container>
    </Container>
  );
};

export default RetireSummaryModalDemo;
